module.exports = __webpack_public_path__ + "static/media/debuff.a2b19e82.png";